// extracted by mini-css-extract-plugin
export default {"crumbsList":"BreadCrumbs_crumbsList__hsXKD","crumb":"BreadCrumbs_crumb__PVhrz","currentCrumb":"BreadCrumbs_currentCrumb__CjP7e"};